import { collectionEngineV1 } from '../apis.js';
const reqCreditors = collectionEngineV1('/creditors');
const reqCreditorsNotTenantScoped = collectionEngineV1('/creditors', false);
export const getAllCreditors = (casualConsistency) => reqCreditors('GET', `/${casualConsistency ? '?casualConsistency=true' : ''}`);
export const get = (id, casualConsistency) => reqCreditors('GET', `/${id}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const update = (id, creditor) => reqCreditors('PATCH', `/${id}`, { body: creditor });
export const create = (creditor) => reqCreditors('POST', `/`, { body: creditor });
export const addChildCompanyToSproom = (creditorId, organizationIdentifier) => reqCreditors('POST', `/add-child-company-sproom/${creditorId}`, {
    body: {
        organizationIdentifier,
    },
});
export const removeChildCompanyFromSproom = (creditorId) => reqCreditors('DELETE', `/remove-child-company-sproom/${creditorId}`);
export const accessTo = () => reqCreditorsNotTenantScoped('GET', `/access`);
export const moveCasesToNewCreditor = (fromCreditorId, toCreditorId) => reqCreditors('POST', '/move-cases-to-creditor', {
    body: {
        fromCreditorId,
        toCreditorId,
    },
});
const reqExperianCreditors = collectionEngineV1('/experian', false);
export const experianUpdate = (id, creditor) => reqExperianCreditors('PATCH', `/${id}`, { body: creditor });
export const experianAskForClientId = (id) => reqExperianCreditors('POST', `/ask-for-client-id/${id}`);
//# sourceMappingURL=creditors.js.map